import { render, staticRenderFns } from "./ResearchPageFilters.vue?vue&type=template&id=2f540b19"
import script from "./ResearchPageFilters.vue?vue&type=script&lang=js"
export * from "./ResearchPageFilters.vue?vue&type=script&lang=js"
import style0 from "./ResearchPageFilters.vue?vue&type=style&index=0&id=2f540b19&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f540b19')) {
      api.createRecord('2f540b19', component.options)
    } else {
      api.reload('2f540b19', component.options)
    }
    module.hot.accept("./ResearchPageFilters.vue?vue&type=template&id=2f540b19", function () {
      api.rerender('2f540b19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchPageFilters.vue"
export default component.exports